
class VerifyEmailController {
  /* @ngInject */
  constructor(
    $window, $state, $location, $rootScope, Auth, AUTH_EVENTS, Session, urls, $http, CAPTCHA_SITE,
  ) {
    this.$window = $window;
    this.$state = $state;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.Auth = Auth;
    this.urls = urls;
    this.AUTH_EVENTS = AUTH_EVENTS;
    this.Session = Session;
    this.CAPTCHA_SITE = CAPTCHA_SITE;
  }

  $onInit() {
  this.show = true;
  this.verifyEmail = true;
  this.sentMail = false;

  this.generateCaptcha();
  }

  generateCaptcha() {
    const that = this;
    grecaptcha.ready(function () {
      grecaptcha.execute(that.CAPTCHA_SITE.KEY,
        { action: 'signup' }).then(function (token) {
        that.recaptuaToken = token;
      });
    });
  }

  sendVerificationEmail() {
    this.$http.get('/users/sendVerify/email',
      { params: {
        type: 'email',
        email: this.data.email,
        recaptuaToken: this.recaptuaToken ,
        } })
      .then(({ data } ) => {
        if (data.status == 404){
          this.show = false;
          this.error = 'Could not find your ShoppRe Account';
        }else if (data.is_email_verified === 0) {
          this.reSendMail = 'Verification Email Sent to Your mail';
          this.verifyEmail = false;
          this.sentMail = true;
        }else {
          this.alreadyVerified = 'Cheers! Your Email already verified';
        }
      }
      )
  }
}

export default VerifyEmailController;



// WEBPACK FOOTER //
// ./client/app/oauth/verify-email/verify-email.controller.js